import { useRive, Alignment, Fit, Layout } from '@rive-app/react-webgl2';
import { useCallback, useState } from 'react';
import styles from './MartyAnimation.module.css';

type Props = {
  asset: string;
  fit?: Fit;
};

export default function MartyAnimation({ asset, fit = Fit.Cover }: Props) {
  const [isReady, setIsReady] = useState(false);
  const onRiveReady = useCallback(() => {
    setIsReady(true);
  }, []);

  const params = {
    src: asset,
    stateMachine: 'Loop',
    layout: new Layout({
      fit,
      alignment: Alignment.Center,
    }),
    autoplay: true,
    onRiveReady,
  };

  const { RiveComponent } = useRive(params, {
    shouldResizeCanvasToContainer: true,
    // Default observer defers startRendering until visible; combined with 0×0 canvas this flashes.
    shouldUseIntersectionObserver: false,
  });

  return (
    <div className={`${styles.Host} ${isReady ? styles.HostReady : ''}`}>
      <RiveComponent />
    </div>
  );
}
